import React from 'react';
import PageHeading from '../../@communityshare/ui/PageHeading';
import ParentLayout from '../settings/Layout';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useNetwork from '../../hooks/useNetwork';
import { Helmet } from 'react-helmet-async';
import { useQueryClient } from '@tanstack/react-query';
import MobileNavigation from '../settings/MobileNavigation';
import NoNetworkSelected from '../settings/NoNetworkSelected';

export default function Layout(props) {
  const network = useNetwork();
  const queryClient = useQueryClient();

  if (!network) {
    return (
      <NoNetworkSelected />
    );
  }

  return (
    <ParentLayout key={network.id}>
      <div className="p-8 space-y-8">
        <Helmet>
          <title>Settings: Grants</title>
        </Helmet>
        <MobileNavigation />
        <PageHeading
          breadcrumbs={['Settings']}
          title="Grants"
          description={(
            <>
              <span className="block">
                Would you like to allow Educators to apply for grant consideration when creating
                a project?
              </span>
            </>
          )}
        />
        {network.state === PayloadStates.FETCHING ? (
          <Loader />
        ) : (
          <Form
            network={network}
            onSubmit={function(request) {
              queryClient.invalidateQueries({ queryKey: ['network'] });
            }}
          />
        )}
      </div>
    </ParentLayout>
  );
}
